import { render, staticRenderFns } from "./SmallFluid.vue?vue&type=template&id=2dd8fa55"
import script from "./SmallFluid.vue?vue&type=script&lang=js"
export * from "./SmallFluid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports